import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Formik } from "formik";
import Select from "react-select";
import PreferredLanguageSelect, { preferredLanguageOrDefault } from "../../../components/preferredLanguageSelect";

import "./edit.css";
import {
  getCountry,
  getLanguages,
  getTimezones,
} from "../../../services/uidata";
import { setLoading } from "../../../reducer/auth/auth";
import { getLegalAndServicesForClient, getProfileBasicInfo, voluntreeClientChangeStaus } from "../../../services/admin";
import { updateInitialProfile } from "../../../services/profile";
import { isLegalConsentAccepted } from "../../../utils/legalConsent";
import {
  capatilizeLetter,
  filterVisibleTimeZones,
  screenNameHandler,
} from "../../../utils/helpers";
import PhoneInputField from "../../../components/Inputfields/phoneinput";
import ToggleTestMode from "../Subcomponents/toogletestmode";
import { updateLegalprivacy } from "../../../services/client";
import Tabs from "../../../components/tabs";
import TabPanel from "../../../components/tabs/tabpanel";
import CopyComponent from "../../../components/copyComponent";
const initialValues = {
  firstName: "",
  lastName: "",
  phone: "",
  screen_name: "",
  whatsapp: "",
  country: "",
  languages: [],
  preferred_communication_language: "",
  timezone: "",
  limit: "",
  referral_code: "",
  extra_tags:"",
  email: "",
  test_mode: 0,
  agree_to_legal_terms_and_conditionss: 0,
  opt_in_out: '',
  questioner: "",
  zoom_verification: 0,
  is_voluntree_client: 0,
  voluntree_client: 0
};
const list = [
  { id: 0, name: "Info" },
  { id: 1, name: "Questions" }
]

export const hasStarterClientProgramActionFlag = (profile) => {
  return Object.prototype.hasOwnProperty.call(
    profile || {},
    "show_starter_client_program_actions"
  );
};

export const shouldShowStarterClientProgramActions = (profile) => {
  if (!profile) {
    return false;
  }

  if (hasStarterClientProgramActionFlag(profile)) {
    return profile.show_starter_client_program_actions === true
      || profile.show_starter_client_program_actions === 1
      || profile.show_starter_client_program_actions === "1";
  }

  const referralCode = String(
    profile.normalized_referral_code || profile.referral_code || ""
  ).trim().toLowerCase();
  const isVoluntreeClient = profile.is_voluntree_client === 1
    || profile.is_voluntree_client === "1"
    || profile.is_voluntree_client === true;

  return isVoluntreeClient && referralCode !== "scv-pif";
};

export const getStarterClientProgramActionState = (action) => {
  if (action === "approve") {
    return {
      showActions: false,
      scvStatus: 0,
    };
  }

  if (action === "reject") {
    return {
      showActions: true,
      scvStatus: 1,
    };
  }

  return null;
};

export default function ClientEdit() {
  const [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get("view");
  const serviceFilterValue = searchParams.get("serviceFilterValue") || "";
  const searchURL = searchParams.get("searchURL") || "clients";
  const searchVal = searchParams.get("search");
  const searchName = searchParams.get("searchName");

  const searchFilterOprater = searchParams.get("searchFilterOprater");
  const searchOprator = searchParams.get("searchOprator");
  const page = searchParams.get('page');
  const rowperpage = searchParams.get('rowperpage');
  const [svcStatus, setScvStatus] = useState(0);
  const [showStarterClientProgramActions, setShowStarterClientProgramActions] = useState(false);


  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formLanguages, setFormLanguages] = useState([]);
  const [newTimezoneData, setNewTimezoneData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [TimezoneData, setTimezoneData] = useState([]);
  const [dataUpdate, setDataUpdate] = useState(false);
  const [valueUpdated, setVlaueUpdated] = useState(true);
  const [listArray, setListArray] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [questioner, setquestioner] = useState("");
  const [queryValue, setQueryValue] = useState('');
  const [query1, setQuery1] = useState('');
  const [query2, setQuery2] = useState('');
  const [query3, setQuery3] = useState('');
  const [query4, setQuery4] = useState('');
  const [query5, setQuery5] = useState('');
  const [query6, setQuery6] = useState('');
  const [query7, setQuery7] = useState('');
  const [query8, setQuery8] = useState('');
  const [profileValues, setProfileValues] = useState(initialValues);



  // const [userCountryCode, setUserCountryCode] = useState("US");


  useEffect(() => {
    localStorage.setItem('pagintionTYPE', 'change')
    // setTimeout(() => {
    // getProfile(params.id);
    getProfile(params.id);
    getLegalData(params.id)
    updateTimeZone();
    updateCountries();
    updateLanguage();
    // }, 2000);
setQuery7(searchURL);
setQuery8(serviceFilterValue);
    setQueryValue(status)
    setQuery1(searchVal)
    setQuery2(searchName)
    setQuery3(page)
    setQuery4(rowperpage)
    setQuery5(searchOprator)
    setQuery6(searchFilterOprater)
    setTimeout(() => {
      removeQueryParams()
    }, 2000);
  }, []);

  const removeQueryParams = () => {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete("view");
    newUrl.searchParams.delete("serviceFilterValue");
    newUrl.searchParams.delete("searchURL");
    
    newUrl.searchParams.delete("search");
    newUrl.searchParams.delete("searchName");
    newUrl.searchParams.delete("searchFilterOprater");

    newUrl.searchParams.delete("searchOprator");
    newUrl.searchParams.delete("page");
    newUrl.searchParams.delete("rowperpage");
    // newUrl.searchParams.delete("id");
    window.history.replaceState({}, document.title, newUrl.href);

  };

  const clearForm = () => {
    initialValues.firstName = "";
    initialValues.lastName = "";
    initialValues.phone = "";
    initialValues.screen_name = "";
    initialValues.whatsapp = "";
    initialValues.country = "";
    initialValues.languages = [];
    initialValues.timezone = "";
    initialValues.limit = "";
    initialValues.referral_code = "";
    initialValues.extra_tags = "";
    initialValues.email = "";
    initialValues.test_mode = 0;
    initialValues.zoom_verification = 0;
    initialValues.agree_to_legal_terms_and_conditionss = 0;
    initialValues.opt_in_out = "";
  }
  const updateCountries = () => {
    getCountry()
      .then((data) => {
        setCountryData(data.data.data);
      })
      .catch((err) => console.log(err));
  };

  const updateLanguage = () => {
    getLanguages()
      .then((data) => {
        setFormLanguages(
          data.data.data.map((item) => {
            return {
              ...item,
              value: item.id,
              label: item.name,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };

  const updateTimeZone = () => {
    getTimezones()
      .then((data) => {
        if (data.data.status) {
          setTimezoneData(data.data.data);
          setNewTimezoneData(data.data.data);
        }
      })
      .catch((err) => console.log(err));
  };
  const reloadTimeZones = (refresh) => {
    getTimezones()
      .then((data) => {
        setTimezoneData(data.data.data);
        setNewTimezoneData(data.data.data);
        if (refresh == "refresh") {
          toast.success("TimeZones Refreshed", { position: "top-center" });
        }
      })
      .catch((err) => console.log(err));
  }
  const RegisterUser = async (formData) => {
    dispatch(setLoading(true));
    const {
      firstName,
      lastName,
      phone,
      whatsapp,
      screen_name,
      country,
      languages,
      timezone,
      limit,
      referral_code,
      extra_tags,
      email,
      test_mode,
      agree_to_legal_terms_and_conditionss,
      opt_in_out,
      comments,
      zoom_verification
    } = formData;

    const elementData = languages.filter(function (element) {
      return element !== undefined;
    });

    const lang = await elementData.map((item) => {
      return item.id;
    });

    let item = {
      first_name: firstName,
      last_name: lastName,
      phone: phone,
      whatsapp: whatsapp,
      country: country,
      languages: lang,
      preferred_communication_language: preferredLanguageOrDefault(formData.preferred_communication_language),
      timezone: timezone,
      userId: params.id,
      screen_name: screen_name,
      limit: limit,
      referral_code: referral_code,
      extra_tags: extra_tags,
      email: email,
      test_mode: test_mode,
      comments: comments,
      zoom_verification: zoom_verification ? 1 : 0,
    };
    let item1 = {
      user_id: params.id,

      agree_to_legal_terms_and_conditionss: agree_to_legal_terms_and_conditionss ? 1 : 0,
      opt_in_out: opt_in_out === "Yes" ? 1 : 0,


    }
    updateInitialProfile(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          toast.success("Profile Updated", { position: "top-center" });
          getProfile(params.id);
        }
      })
      .catch((error) => {
        dispatch(setLoading(false));
        console.log(error);
      });

    updateLegalprivacy(item1).then(() => { }).catch(() => { })
  };
  // const getProfile = (id) => {
  //   dispatch(setLoading(true));
  //   getProfileBasicInfo(id)
  //     .then((data) => {
  //       dispatch(setLoading(false));

  //       if (data.data.status) {
  //         const {
  //           country,
  //           first_name,
  //           last_name,
  //           screen_name,
  //           languages,
  //           phone,
  //           whatsapp,
  //           timezone,
  //           limit,
  //           referral_code,
  //           extra_tags,
  //           email,
  //           test_mode,
  //           comments,
  //           questioner,
  //           zoom_verification,
  //           is_voluntree_client,
  //           voluntree_client
  //         } = data.data.data;
  //         initialValues.firstName = first_name;
  //         initialValues.lastName = last_name;
  //         initialValues.country = country;
  //         initialValues.phone = phone;
  //         initialValues.languages = updateIncomingHandler(
  //           languages,
  //           "languages"
  //         );
  //         initialValues.whatsapp = whatsapp;
  //         initialValues.timezone = timezone.id;
  //         initialValues.screen_name = screen_name;
  //         initialValues.limit = limit;
  //         initialValues.referral_code = referral_code;
  //         initialValues.extra_tags = extra_tags;
  //         initialValues.email = email;
  //         initialValues.test_mode = test_mode;
  //         initialValues.comments = comments;
  //         initialValues.zoom_verification = zoom_verification == 1 ? true : false;
  //         initialValues.is_voluntree_client = is_voluntree_client;
  //         initialValues.voluntree_client = is_voluntree_client;
  //         setIsVoluntreeClient(is_voluntree_client);
  //         data.data.data && data.data.data.questioner ? setListArray(list) : setListArray([])


  //         setquestioner(questioner);
  //         // setProfileSection(data.data.data);
  //         const info = data.data.data;
        
  //       // Update the state instead of the external initialValues object
  //       setProfileValues({
  //         ...initialValues,
  //         firstName: info.first_name,
  //         lastName: info.last_name,
  //         country: info.country,
  //         phone: info.phone,
  //         languages: updateIncomingHandler(info.languages, "languages"),
  //         whatsapp: info.whatsapp,
  //         timezone: info.timezone.id,
  //         screen_name: info.screen_name,
  //         limit: info.limit,
  //         referral_code: info.referral_code,
  //         extra_tags: info.extra_tags,
  //         email: info.email,
  //         test_mode: info.test_mode,
  //         comments: info.comments,
  //         zoom_verification: info.zoom_verification == 1,
  //         is_voluntree_client: info.is_voluntree_client,
  //         voluntree_client: info.is_voluntree_client
  //       });
  //         setDataUpdate(true)
  //       }
  //     })
  //     .catch((err) => {
  //       dispatch(setLoading(false));
  //       console.log(err);
  //       setDataUpdate(false)
  //     });
  // };

  const getProfile = (id) => {
  dispatch(setLoading(true));
  getProfileBasicInfo(id)
    .then((data) => {
      dispatch(setLoading(false));
      if (data.data.status) {
        const info = data.data.data;
        setScvStatus(info.scv_status);
        setShowStarterClientProgramActions(shouldShowStarterClientProgramActions(info));
        // Use a functional update to keep existing values (like legal data)
        setProfileValues((prev) => ({
          ...prev,
          firstName: info.first_name || "",
          lastName: info.last_name || "",
          country: info.country || "",
          phone: info.phone || "",
          languages: updateIncomingHandler(info.languages, "languages") || [],
          preferred_communication_language: info.preferred_communication_language || "",
          whatsapp: info.whatsapp || "",
           timezone: (info.timezone && info.timezone.id) || "", 
          screen_name: info.screen_name || "",
          limit: info.limit || "",
          referral_code: info.referral_code || "",
          extra_tags: info.extra_tags || "",
          email: info.email || "",
          test_mode: info.test_mode || 0,
          comments: info.comments || "",
          zoom_verification: info.zoom_verification == 1,
          is_voluntree_client: info.is_voluntree_client,
          voluntree_client: info.is_voluntree_client
        }));
        
        setquestioner(info.questioner);
        setListArray(info.questioner ? list : []);
        setDataUpdate(true);
      }
    })
    .catch((err) => {
      dispatch(setLoading(false));
      setDataUpdate(false);
    });
};

  const checkTimeZone = (timezone) => {
    // console.log(initialValues.timezone , "timezone" , TimezoneData ,"TimezoneData")
    if (initialValues.timezone !== "" && TimezoneData.length > 0) {
      let time = TimezoneData.filter(
        (item) => item.id === initialValues.timezone
      );
      let status = time[0].status;
      console.log(time[0])
      let info = time[0];
      let newinfo = newTimezoneData;
      // console.log(info)
      if (status === 0) {
        let time = newTimezoneData.filter(
          (item) => item.id === initialValues.timezone
        );
        console.log(time, !time.length, "ytime")
        if (!time.length) {
          newinfo.push({ ...info, status: 1 });
          setNewTimezoneData(newinfo);
        }
      }
    }
  };
  const updateIncomingHandler = (items, type) => {
    let incomingArray;
    if (type === "languages") {
      incomingArray = items.map((item) => {
        return {
          ...item,
          id: item.language_id,
          value: item.language_id,
          label: item.lanugage_name,
        };
      });
    }
    return incomingArray;
  };

  const capatilizeLetters = (e, name, setFieldValue, uservalues) => {
    let values = e.target.value;
    const input = capatilizeLetter(values);
    setFieldValue(name, input);

    if (uservalues.firstName !== "") {
      setFieldValue(
        "screen_name",
        screenNameHandler(
          name === "firstName" ? e.target.value : uservalues.firstName,
          name === "lastName" ? e.target.value : uservalues.lastName
        )
      );
    }
    if (e.target.name === "firstName" && e.target.value === "") {
      setFieldValue("screen_name", "");
    }
  };

  const countryChangeHandler = (e, name, setFieldValue) => {
    let value = e.target.value;
    // if (value) {
    //   setUserCountryCode(getCountryCode(value ,countryData));
    // }
    setFieldValue(name, value);
  };

  const getLegalData = (id) => {
    getLegalAndServicesForClient(id).then((data) => {
      console.log(data.data)
      if (data.data.status) {
        setVlaueUpdated(true)
        console.log(data.data.data);
        let info = data.data.data
        // Merge into the actual form state instead of the unused module-level
        // `initialValues` object -- writing to that object raced with getProfile()'s
        // setProfileValues() call and, depending on which resolved first, could
        // silently drop the fetched legal-consent / opt-in values (and later
        // resubmit stale ones back to the server on save).
        setProfileValues((prev) => ({
          ...prev,
          agree_to_legal_terms_and_conditionss: isLegalConsentAccepted(info.agree_to_legal_terms_and_conditionss),
          opt_in_out: info.opt_in_out === 1 ? 'Yes' : info.opt_in_out === 0 ? 'No' : '',
        }));
      }
    }).catch(() => { });

  }
  const potentialStatus = (status) => {
    if(svcStatus == 1) return;
    let client_id = params.id;
    let action = status;
    let body = {
      client_id: client_id,
      action: status
    }
    voluntreeClientChangeStaus(body).then((data) => {
      if (data.data.status) {
        toast.success("Status updated succesfully", {
          position: "top-center",
        });
        const updatedActionState = getStarterClientProgramActionState(status);
        if (updatedActionState) {
          setShowStarterClientProgramActions(updatedActionState.showActions);
          setScvStatus(updatedActionState.scvStatus);
        }
      }
      else {
        toast.error("Something went wrong", { position: "top-center" });
      }
    })

  };
  return (
    <>
      <div className="back-btn-profile ml-2 container-fluid">
        <span
          className="back-handler pointer"
          onClick={() => {
            clearForm();
           if (status === null) {
                navigate(-1);
              } else {
                let url = `/${query7}?view=${queryValue}&search=${query1}&searchName=${query2}&page=${query3}&rowperpage=${query4}&searchOprator=${query5}&searchFilterOprater=${query6}&pagintion=change`;

                if (query7 !== 'clients') {
                  url += `&serviceFilterValue=${query8}`;
                }

                navigate(url);
              }
          }}
        >
          <img src="../images/arrow-back.png" alt="go back" />
          Go Back
        </span>
      </div>
      <div className={listArray.length > 0 ? "all-medium-page" : ''}>
        <Tabs active={activeTab} list={listArray} setActiveTab={setActiveTab} />

        <ul className="tabs-content">
          <TabPanel id={0} activeTab={activeTab}>
            {dataUpdate ? <>  <div className="login-register-saction registernew">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="login-saction-right register-right register-clint">
                      <div className="form-l---r">
                        <Formik
                          enableReinitialize={true} // CRITICAL: This allows the form to update when profileValues changes
  initialValues={profileValues} // Use the state variable here
                          validate={(values) => {
                            const errors = {};
                            if (!values.firstName) errors.firstName = "Required";
                            if (!values.lastName) errors.lastName = "Required";
                            // // if (values.phone && !/^[0-9]+$/.test(values.phone)) {
                            // //   errors.phone = "Invalid Phone";
                            // // }
                            // if (values.whatsapp && !/^[0-9]+$/.test(values.whatsapp)) {
                            //   errors.whatsapp = "Invalid whatsapp";
                            // }

                            if (
                              values.website &&
                              !/^[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(
                                values.website
                              )
                            ) {
                              errors.website = "Invalid Website";
                            }
                            if (!values.country) errors.country = "Required";
                            if (!values.timezone) errors.timezone = "Required";

                            if (!values.languages) errors.languages = "Required";
                            if (!values.email) errors.email = "Required";
                            return errors;
                          }}
                          onSubmit={(values, { setSubmitting }) => {
                            RegisterUser(values);
                            // setOpen(true);
                            // setTimeout(() => {
                            //   alert(JSON.stringify(values, null, 2));
                            //   setSubmitting(false);
                            // }, 400);
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                          }) => (
                            <form onSubmit={handleSubmit}>

                              <div className="from-fild">
                                <div className="icon">
                                  <img alt="user" src="/images/user.png" />
                                </div>
                                <label htmlFor="firstName">First Name*</label>
                                <input
                                  className={`${errors.firstName &&
                                    touched.firstName &&
                                    errors.firstName
                                    ? "error-boundry"
                                    : ""
                                    }`}
                                  onChange={(e) =>
                                    capatilizeLetters(
                                      e,
                                      "firstName",
                                      setFieldValue,
                                      values
                                    )
                                  }
                                  onBlur={handleBlur}
                                  value={values.firstName}
                                  type="text"
                                  id="firstName"
                                  name="firstName"
                                  placeholder="First Name"
                                />
                                <span className="error">
                                  {errors.firstName &&
                                    touched.firstName &&
                                    errors.firstName}
                                </span>
                              </div>

                              <div className="from-fild">
                                <div className="icon">
                                  <img alt="user" src="/images/user.png" />
                                </div>
                                <label htmlFor="lastName">Last Name*</label>
                                <input
                                  className={`${errors.lastName &&
                                    touched.lastName &&
                                    errors.lastName
                                    ? "error-boundry"
                                    : ""
                                    }`}
                                  onChange={(e) =>
                                    capatilizeLetters(
                                      e,
                                      "lastName",
                                      setFieldValue,
                                      values
                                    )
                                  }
                                  onBlur={handleBlur}
                                  value={values.lastName}
                                  type="text"
                                  id="lastName"
                                  name="lastName"
                                  placeholder="Last Name"
                                />
                                <span className="error">
                                  {errors.lastName &&
                                    touched.lastName &&
                                    errors.lastName}
                                </span>
                              </div>


                              <div className="from-fild">
                                <div className="icon">
                                  <img alt="phone" src="/images/phon.png" />
                                </div>
                                <label htmlFor="phone">Phone</label>
                                <PhoneInputField
                                  className={`number-input ${errors.phone && touched.phone && errors.phone
                                    ? "error-boundry"
                                    : ""
                                    }`}
                                  // country={userCountryCode.toLowerCase()}
                                  setFieldValue={setFieldValue}
                                  onBlur={handleBlur}
                                  value={values.phone}
                                  id="phone"
                                  name="phone"
                                />
                                <div className="copy-icon">
                                  <CopyComponent value={values.phone} />
                                </div>
                                <span className="error">
                                  {errors.phone && touched.phone && errors.phone}
                                </span>
                              </div>


                              <div className="from-fild input-container">
                                <div className="icon">
                                  <img alt="whatsapp" src="/images/whtsp.png" />
                                </div>
                                <label htmlFor="whatsapp">Whatsapp</label>
                                <PhoneInputField
                                  className={`${errors.whatsapp &&
                                    touched.whatsapp &&
                                    errors.whatsapp
                                    ? "error-boundry"
                                    : ""
                                    }`}
                                  // country={userCountryCode.toLowerCase()}
                                  setFieldValue={setFieldValue}
                                  onBlur={handleBlur}
                                  value={values.whatsapp}
                                  id="whatsapp"
                                  name="whatsapp"
                                />
                                <div className="copy-icon">
                                  <CopyComponent value={values.whatsapp} />
                                </div>
                                <span className="error">
                                  {errors.whatsapp &&
                                    touched.whatsapp &&
                                    errors.whatsapp}
                                </span>
                              </div>
                              <div className="from-fild">
                                <div className="icon">
                                  <img src="/images/australia.png" alt="country" />
                                </div>
                                <label htmlFor="country">
                                  Country<i>*</i>
                                </label>
                                <select
                                  className={`selectmenu-element form-item__element--select has-placeholder ${errors.country &&
                                    touched.country &&
                                    errors.country
                                    ? "error-boundry"
                                    : ""
                                    }`}
                                  data-name="selectmenu-1"
                                  // id="my-selectmenu"
                                  onChange={(value) =>
                                    countryChangeHandler(
                                      value,
                                      "country",
                                      setFieldValue
                                    )
                                  }
                                  onBlur={handleBlur}
                                  value={values.country}
                                  type="text"
                                  id="country"
                                  name="country"
                                  placeholder="Country"
                                >
                                  <option disabled="" selected="" value="">
                                    Country<i>*</i>
                                  </option>
                                  {countryData.map((country) => (
                                    <option value={country.country_name}>
                                      {/* <span className="d-none">{country.id}</span> */}
                                      {country.country_name}
                                    </option>
                                  ))}
                                </select>
                                {/* <input
                            className={`${
                              errors.country &&
                              touched.country &&
                              errors.country
                                ? "error-boundry"
                                : ""
                            }`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.country}
                            type="text"
                            id="country"
                            name="country"
                            placeholder="Country"
                          /> */}
                                <span className="error">
                                  {errors.country &&
                                    touched.country &&
                                    errors.country}
                                </span>
                              </div>

                              <div className="from-fild">
                                <div className="icon">
                                  <img alt="user" src="/images/user.png" />
                                </div>
                                <label htmlFor="firstName">Screen Name*</label>
                                <input
                                  className={`${errors.screen_name &&
                                    touched.screen_name &&
                                    errors.screen_name
                                    ? "error-boundry"
                                    : ""
                                    }`}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.screen_name}
                                  type="text"
                                  id="screen_name"
                                  name="screen_name"
                                  placeholder="Screen Name"
                                />
                                <span className="error">
                                  {errors.screen_name &&
                                    touched.screen_name &&
                                    errors.screen_name}
                                </span>
                              </div>
                              {/* /languages */}

                              <div className="from-fild">
                                <div className="icon">
                                  <img src="/images/australia.png" alt="languages" />
                                </div>
                                <label htmlFor="languages">
                                  Languages<i>*</i>
                                </label>
                                {/* {values.languages.length > 0 && ( */}
                                <Select
                                  id="languages"
                                  className="selection-box client-selection-box"
                                  options={formLanguages}
                                  multi={true}
                                  isMulti
                                  onChange={(value) =>
                                    setFieldValue("languages", value)
                                  }
                                  onBlur={handleBlur}
                                  placeholder="Select languages"
                                  value={values.languages}
                                  closeMenuOnSelect={false}
                                  closeMenuOnScroll={false}
                                />
                                {/* )}*/}
                                {/* )} */}
                                {/* <input
                            className={`${
                              errors.languages &&
                              touched.languages &&
                              errors.languages
                                ? "error-boundry"
                                : ""
                            }`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.languages}
                            type="text"
                            id="languages"
                            name="languages"
                            placeholder="Languages"
                          /> */}
                                <span className="error">
                                  {errors.languages &&
                                    touched.languages &&
                                    errors.languages}
                                </span>
                              </div>
                              <div className="from-fild">
                                <div className="icon">
                                  <img src="/images/australia.png" alt="" />
                                </div>
                                <label htmlFor="preferred_communication_language">
                                  Preferred Language for Communications<i>*</i>
                                </label>
                                <PreferredLanguageSelect
                                  className="selection-box client-selection-box"
                                  value={preferredLanguageOrDefault(values.preferred_communication_language)}
                                  onChange={(code) => setFieldValue("preferred_communication_language", code)}
                                  onBlur={handleBlur}
                                />
                              </div>
                              {/* timezone */}
                              <div className="from-fild">
                                <div className="icon">
                                  <img src="/images/australia.png" alt="timezone" />
                                </div>
                                <label htmlFor="timezone">
                                  Timezone<i>*</i>
                                  {/* <img
                                    title="Reload TimeZones"
                                    onClick={(e) => reloadTimeZones("refresh")}
                                    className="googl-link-copy-img copy-image-animate refresh-btn-app mt-4"
                                    alt="Reload TimeZones"
                                    src="/images/refresh.png"
                                  /> */}
                                </label>

                                {/* {timezoneOnly && ( */}
                                {checkTimeZone()}
                                <select
                                  className={`selectmenu-element form-item__element--select has-placeholder ${errors.timezone &&
                                    touched.timezone &&
                                    errors.timezone
                                    ? "error-boundry"
                                    : ""
                                    }`}
                                  // id="my-selectmenu"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.timezone}
                                  type="text"
                                  id="timezone"
                                  name="timezone"
                                  placeholder="Timezone"
                                >
                                  <option disabled="" selected="" value="">
                                    Timezone<i>*</i>
                                  </option>
                                  {newTimezoneData.map((timezone) => (
                                    <option value={timezone.id}>
                                      {/* <span className="d-none">{country.id}</span> */}
                                      {timezone.front_name}
                                    </option>
                                  ))}
                                </select>
                                {/* )} */}
                                {/* <input
                            className={`${
                              errors.languages &&
                              touched.languages &&
                              errors.languages
                                ? "error-boundry"
                                : ""
                            }`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.languages}
                            type="text"
                            id="languages"
                            name="languages"
                            placeholder="Languages"
                          /> */}
                                <span className="error">
                                  {errors.timezone &&
                                    touched.timezone &&
                                    errors.timezone}
                                </span>
                              </div>
                              <div className="from-fild clear-both">
                                <div className="icon">
                                  <img alt="user" src="/images/user.png" />
                                </div>
                                <label htmlFor="limit">Limit</label>
                                <input
                                  className="box-sizing-border-box"
                                  // className={`${
                                  //   errors.limit &&
                                  //   touched.limit &&
                                  //   errors.limit
                                  //     ? "error-boundry"
                                  //     : ""
                                  // }`}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.limit}
                                  type="text"
                                  id="limit"
                                  name="limit"
                                  placeholder="Limit"
                                />
                                {/* <span className="error">
                          {errors.firstName &&
                            touched.firstName &&
                            errors.firstName}
                        </span> */}

                              </div>
                              <div className="from-fild">
                                <div className="icon">
                                  <img alt="user" src="/images/user.png" />
                                </div>
                                <label htmlFor="referral_code">Referral Code</label>
                                <input
                                  className="box-sizing-border-box"
                                  // className={`${
                                  //   errors.limit &&
                                  //   touched.limit &&
                                  //   errors.limit
                                  //     ? "error-boundry"
                                  //     : ""
                                  // }`}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.referral_code}
                                  type="text"
                                  id="referral_code"
                                  name="referral_code"
                                  placeholder="Referral Code"
                                />
                                {/* <span className="error">
                        {errors.firstName &&
                          touched.firstName &&
                          errors.firstName}
                      </span> */}
                              </div>
                              <div className="from-fild ">

                                <label htmlFor="limit">Comment</label>
                                <textarea
                                  className="box-sizing-border-box text-are-client p-2"
                                  rows={14}

                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.comments}

                                  id="comments"
                                  name="comments"
                                // placeholder="Limit"
                                />
                                {/* <span className="error">
                          {errors.firstName &&
                            touched.firstName &&
                            errors.firstName}
                        </span> */}

                              </div>
                              <div className="from-fild">

                                <div className="icon">
                                  <img alt="email" src="/images/mail.png" />
                                </div>
                                <label htmlFor="email">Email</label>
                                <input
                                  className={`${errors.email &&
                                    touched.email &&
                                    errors.email
                                    ? "error-boundry"
                                    : ""
                                    }`}

                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.email}
                                  type="email"
                                  id="email"
                                  name="email"
                                  placeholder="myemail@address.com"
                                />
                                <div className="copy-icon">
                                  <CopyComponent value={values.email} />
                                </div>
                                <span className="error">
                                  {errors.email &&
                                    touched.email &&
                                    errors.email}
                                </span>
                              </div>
<div className="from-fild">
                                <div className="icon">
                                  <img alt="user" src="/images/list_m.png" />
                                </div>
                                <label htmlFor="extra_tags">Extra Tags</label>
                                <input
                                  className="box-sizing-border-box"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.extra_tags}
                                  type="text"
                                  id="extra_tags"
                                  name="extra_tags"
                                  placeholder="Extra Tags"
                                  
                                />
                                </div>
                              {showStarterClientProgramActions &&(
                                <div className="from-fild">
                                <label htmlFor="email">Starter Client Program</label>



                                <>
                                {svcStatus != 1  &&
                                  <div className="bution mt-0">
                                    <button type="button" className="button-bx" onClick={() => potentialStatus('approve')}>
                                      Approve
                                    </button>
                                  </div>
                                  }

                                  <div className="bution mt-3">
                                    <button type="button" className={`button-bx ${svcStatus == 1 ? 'rejected-btn' : ''}`} disabled={svcStatus == 1} onClick={() => potentialStatus('reject')}>
                                     {svcStatus == 1 ? 'Rejected' : 'Reject'}
                                    </button>
                                  </div>
                                </>
                              </div>
                              )} 

                              <div className="clear-both">

                                <div className="from-fild">
                                  <div className="icon">

                                  </div>
                                  <label htmlFor="test_mode" className="mb-4">Test Mode</label>
                                  <>
                                    <ToggleTestMode item={values} setFieldValue={setFieldValue} stepOneData={profileValues} />
                                  </>
                                </div>
                              </div>
                              {/* //email */}



                              {valueUpdated && <>
                                <div className="from-inner-box">
                                  <div className="full-fild mt-3">
                                    <label>
                                      Legal and Privacy <i>*</i>
                                    </label>
                                    <span className="error marg-top-55">

                                    </span>
                                    <div className="prvacy-box">
                                      <input
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value="I have read and agree to the terms and conditions"
                                        id="termsandconditions"
                                        type="checkbox"
                                        name="agree_to_legal_terms_and_conditionss"
                                        // disabled
                                        checked={isLegalConsentAccepted(values.agree_to_legal_terms_and_conditionss)}
                                      />

                                      <label htmlFor="termsandconditions" className="width-unset">
                                        I have read and agree to the terms and conditions.
                                      </label>
                                      <div className="tr-pr">
                                        <Link to="/terms-conditions" target="_blank">
                                          Terms &amp; Conditions
                                        </Link>
                                        <Link to="/privacy-policy" target="_blank">
                                          Privacy Policy
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="from-inner-box radeo check-box-input payment-saction mt-3">
                                  <div className="full-fild">
                                    <label>
                                      Opt-In? <i>*</i>
                                    </label>
                                    <h4>
                                      I would like to receive notices of offers (for free events,
                                      opportunities, etc.)
                                    </h4>
                                    <div className="check-field">
                                      <input
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value="Yes"
                                        id="opt_in"
                                        type="radio"
                                        name="opt_in_out"
                                        checked={values.opt_in_out === "Yes" ? 'checked' : ''}
                                      />
                                      {/* {console.log(values.opt_in_out, "values.opt_in_out ")} */}
                                      <label htmlFor="optin">Yes</label>
                                    </div>
                                    <div className="check-field">
                                      <input
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value="No"
                                        id="opt_out"
                                        type="radio"
                                        name="opt_in_out"
                                        checked={values.opt_in_out === "No" ? 'checked' : ''}
                                      />
                                      <label htmlFor="optout">No</label>
                                    </div>
                                  </div>
                                  <span className="error marg-top-55">
                                    {/* {errors.opt_in_out && touched.opt_in_out && errors.opt_in_out} */}
                                  </span>
                                </div>
                              </>}
                              <div className="from-inner-box clear-both">
                                <div className="full-fild mt-5">


                                  <div className="prvacy-box">
                                    <input
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value="I have read and agree to the terms and conditions"
                                      id="zoom_verification"
                                      type="checkbox"
                                      name="zoom_verification"

                                      checked={values.zoom_verification ? 'checked' : ''}
                                    />

                                    <label htmlFor="zoom_verification" className="width-unset">
                                      Able to connect to zoom
                                    </label>

                                  </div>
                                </div>
                              </div>
                              <div className="bution d-flex justify-content-between">
                                <button type="submit" className="button-bx">
                                  Update
                                </button>
                              
                              </div>
                            </form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </>
              :
              <> <div className="login-register-saction registernew">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="login-saction-right register-right register-clint">
                        <div className="form-l---r">
                          <Formik
                            enableReinitialize={true} // CRITICAL: This allows the form to update when profileValues changes
  initialValues={profileValues} // Use the state variable here
                            validate={(values) => {
                              const errors = {};
                              if (!values.firstName) errors.firstName = "Required";
                              if (!values.lastName) errors.lastName = "Required";
                              // // if (values.phone && !/^[0-9]+$/.test(values.phone)) {
                              // //   errors.phone = "Invalid Phone";
                              // // }
                              // if (values.whatsapp && !/^[0-9]+$/.test(values.whatsapp)) {
                              //   errors.whatsapp = "Invalid whatsapp";
                              // }

                              if (
                                values.website &&
                                !/^[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(
                                  values.website
                                )
                              ) {
                                errors.website = "Invalid Website";
                              }
                              if (!values.country) errors.country = "Required";
                              if (!values.timezone) errors.timezone = "Required";

                              if (!values.languages) errors.languages = "Required";
                              return errors;
                            }}
                            onSubmit={(values, { setSubmitting }) => {
                              RegisterUser(values);
                              // setOpen(true);
                              // setTimeout(() => {
                              //   alert(JSON.stringify(values, null, 2));
                              //   setSubmitting(false);
                              // }, 400);
                            }}
                          >
                            {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              setFieldValue,
                              handleSubmit,
                              isSubmitting,
                            }) => (
                              <form onSubmit={handleSubmit}>

                                <div className="from-fild">
                                  <div className="icon">
                                    <img alt="user" src="/images/user.png" />
                                  </div>
                                  <label htmlFor="firstName">First Name*</label>
                                  <input
                                    className={`${errors.firstName &&
                                      touched.firstName &&
                                      errors.firstName
                                      ? "error-boundry"
                                      : ""
                                      }`}
                                    onChange={(e) =>
                                      capatilizeLetters(
                                        e,
                                        "firstName",
                                        setFieldValue,
                                        values
                                      )
                                    }
                                    onBlur={handleBlur}
                                    value={values.firstName}
                                    type="text"
                                    id="firstName"
                                    name="firstName"
                                    placeholder="First Name"
                                  />
                                  <span className="error">
                                    {errors.firstName &&
                                      touched.firstName &&
                                      errors.firstName}
                                  </span>
                                </div>

                                <div className="from-fild">
                                  <div className="icon">
                                    <img alt="user" src="/images/user.png" />
                                  </div>
                                  <label htmlFor="lastName">Last Name*</label>
                                  <input
                                    className={`${errors.lastName &&
                                      touched.lastName &&
                                      errors.lastName
                                      ? "error-boundry"
                                      : ""
                                      }`}
                                    onChange={(e) =>
                                      capatilizeLetters(
                                        e,
                                        "lastName",
                                        setFieldValue,
                                        values
                                      )
                                    }
                                    onBlur={handleBlur}
                                    value={values.lastName}
                                    type="text"
                                    id="lastName"
                                    name="lastName"
                                    placeholder="Last Name"
                                  />
                                  <span className="error">
                                    {errors.lastName &&
                                      touched.lastName &&
                                      errors.lastName}
                                  </span>
                                </div>

                                <div className="from-fild">
                                  <div className="icon">
                                    <img alt="phone" src="/images/phon.png" />
                                  </div>
                                  <label htmlFor="phone">Phone</label>
                                  <PhoneInputField
                                    className={`number-input ${errors.phone && touched.phone && errors.phone
                                      ? "error-boundry"
                                      : ""
                                      }`}
                                    // country={userCountryCode.toLowerCase()}
                                    setFieldValue={setFieldValue}
                                    onBlur={handleBlur}
                                    value={values.phone}
                                    id="phone"
                                    name="phone"
                                  />
                                  <span className="error">
                                    {errors.phone && touched.phone && errors.phone}
                                  </span>
                                </div>

                                <div className="from-fild">
                                  <div className="icon">
                                    <img alt="whatsapp" src="/images/whtsp.png" />
                                  </div>
                                  <label htmlFor="whatsapp">Whatsapp</label>
                                  <PhoneInputField
                                    className={`${errors.whatsapp &&
                                      touched.whatsapp &&
                                      errors.whatsapp
                                      ? "error-boundry"
                                      : ""
                                      }`}
                                    // country={userCountryCode.toLowerCase()}
                                    setFieldValue={setFieldValue}
                                    onBlur={handleBlur}
                                    value={values.whatsapp}
                                    id="whatsapp"
                                    name="whatsapp"
                                  />
                                  <span className="error">
                                    {errors.whatsapp &&
                                      touched.whatsapp &&
                                      errors.whatsapp}
                                  </span>
                                </div>
                                <div className="from-fild">
                                  <div className="icon">
                                    <img src="/images/australia.png" alt="country" />
                                  </div>
                                  <label htmlFor="country">
                                    Country<i>*</i>
                                  </label>
                                  <select
                                    className={`selectmenu-element form-item__element--select has-placeholder ${errors.country &&
                                      touched.country &&
                                      errors.country
                                      ? "error-boundry"
                                      : ""
                                      }`}
                                    data-name="selectmenu-1"
                                    // id="my-selectmenu"
                                    onChange={(value) =>
                                      countryChangeHandler(
                                        value,
                                        "country",
                                        setFieldValue
                                      )
                                    }
                                    onBlur={handleBlur}
                                    value={values.country}
                                    type="text"
                                    id="country"
                                    name="country"
                                    placeholder="Country"
                                  >
                                    <option disabled="" selected="" value="">
                                      Country<i>*</i>
                                    </option>
                                    {countryData.map((country) => (
                                      <option value={country.country_name}>
                                        {/* <span className="d-none">{country.id}</span> */}
                                        {country.country_name}
                                      </option>
                                    ))}
                                  </select>
                                  {/* <input
                          className={`${
                            errors.country &&
                            touched.country &&
                            errors.country
                              ? "error-boundry"
                              : ""
                          }`}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.country}
                          type="text"
                          id="country"
                          name="country"
                          placeholder="Country"
                        /> */}
                                  <span className="error">
                                    {errors.country &&
                                      touched.country &&
                                      errors.country}
                                  </span>
                                </div>

                                <div className="from-fild">
                                  <div className="icon">
                                    <img alt="user" src="/images/user.png" />
                                  </div>
                                  <label htmlFor="firstName">Screen Name*</label>
                                  <input
                                    className={`${errors.screen_name &&
                                      touched.screen_name &&
                                      errors.screen_name
                                      ? "error-boundry"
                                      : ""
                                      }`}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.screen_name}
                                    type="text"
                                    id="screen_name"
                                    name="screen_name"
                                    placeholder="Screen Name"
                                  />
                                  <span className="error">
                                    {errors.screen_name &&
                                      touched.screen_name &&
                                      errors.screen_name}
                                  </span>
                                </div>
                                {/* /languages */}

                                <div className="from-fild">
                                  <div className="icon">
                                    <img src="/images/australia.png" alt="languages" />
                                  </div>
                                  <label htmlFor="languages">
                                    Languages<i>*</i>
                                  </label>
                                  {/* {values.languages.length > 0 && ( */}
                                  <Select
                                    id="languages"
                                    className="selection-box client-selection-box"
                                    options={formLanguages}
                                    multi={true}
                                    isMulti
                                    onChange={(value) =>
                                      setFieldValue("languages", value)
                                    }
                                    onBlur={handleBlur}
                                    placeholder="Select languages"
                                    value={values.languages}
                                    closeMenuOnSelect={false}
                                    closeMenuOnScroll={false}
                                  />
                                  {/* )}*/}
                                  {/* )} */}
                                  {/* <input
                          className={`${
                            errors.languages &&
                            touched.languages &&
                            errors.languages
                              ? "error-boundry"
                              : ""
                          }`}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.languages}
                          type="text"
                          id="languages"
                          name="languages"
                          placeholder="Languages"
                        /> */}
                                  <span className="error">
                                    {errors.languages &&
                                      touched.languages &&
                                      errors.languages}
                                  </span>
                                </div>
                              <div className="from-fild">
                                <div className="icon">
                                  <img src="/images/australia.png" alt="" />
                                </div>
                                <label htmlFor="preferred_communication_language">
                                  Preferred Language for Communications<i>*</i>
                                </label>
                                <PreferredLanguageSelect
                                  className="selection-box client-selection-box"
                                  value={preferredLanguageOrDefault(values.preferred_communication_language)}
                                  onChange={(code) => setFieldValue("preferred_communication_language", code)}
                                  onBlur={handleBlur}
                                />
                              </div>
                                {/* timezone */}
                                <div className="from-fild">
                                  <div className="icon">
                                    <img src="/images/australia.png" alt="timezone" />
                                  </div>
                                  <label htmlFor="timezone">
                                    Timezone<i>*</i>
                                  </label>
                                  {/* {timezoneOnly && ( */}
                                  {checkTimeZone()}
                                  <select
                                    className={`selectmenu-element form-item__element--select has-placeholder ${errors.timezone &&
                                      touched.timezone &&
                                      errors.timezone
                                      ? "error-boundry"
                                      : ""
                                      }`}
                                    // id="my-selectmenu"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.timezone}
                                    type="text"
                                    id="timezone"
                                    name="timezone"
                                    placeholder="Timezone"
                                  >
                                    <option disabled="" selected="" value="">
                                      Timezone<i>*</i>
                                    </option>
                                    {newTimezoneData.map((timezone) => (
                                      <option value={timezone.id}>
                                        {/* <span className="d-none">{country.id}</span> */}
                                        {timezone.front_name}
                                      </option>
                                    ))}
                                  </select>
                                  {/* )} */}
                                  {/* <input
                          className={`${
                            errors.languages &&
                            touched.languages &&
                            errors.languages
                              ? "error-boundry"
                              : ""
                          }`}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.languages}
                          type="text"
                          id="languages"
                          name="languages"
                          placeholder="Languages"
                        /> */}
                                  <span className="error">
                                    {errors.timezone &&
                                      touched.timezone &&
                                      errors.timezone}
                                  </span>
                                </div>
                                <div className="from-fild clear-both">
                                  <div className="icon">
                                    <img alt="user" src="/images/user.png" />
                                  </div>
                                  <label htmlFor="limit">Limit</label>
                                  <input
                                    className="box-sizing-border-box"
                                    // className={`${
                                    //   errors.limit &&
                                    //   touched.limit &&
                                    //   errors.limit
                                    //     ? "error-boundry"
                                    //     : ""
                                    // }`}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.limit}
                                    type="text"
                                    id="limit"
                                    name="limit"
                                    placeholder="Limit"
                                  />
                                  {/* <span className="error">
                        {errors.firstName &&
                          touched.firstName &&
                          errors.firstName}
                      </span> */}
                                </div>
                                <div className="from-fild">
                                  <div className="icon">
                                    <img alt="user" src="/images/user.png" />
                                  </div>
                                  <label htmlFor="referral_code">Referral Code</label>
                                  <input
                                    className="box-sizing-border-box"
                                    // className={`${
                                    //   errors.limit &&
                                    //   touched.limit &&
                                    //   errors.limit
                                    //     ? "error-boundry"
                                    //     : ""
                                    // }`}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.referral_code}
                                    type="text"
                                    id="referral_code"
                                    name="referral_code"
                                    placeholder="Referral Code"
                                  />
                                  {/* <span className="error">
                        {errors.firstName &&
                          touched.firstName &&
                          errors.firstName}
                      </span> */}
                                </div>
                                <div>
                                  {/* <div className="from-fild">
                              <div className="icon">
                        
                              </div>
                              <label htmlFor="test_mode" className="mb-4">Test Mode</label>
                              <>
                                <ToggleTestMode item={values} setFieldValue={setFieldValue} stepOneData={initialValues} />
                              </>
                            </div> */}
                                </div>
                                <div className="from-inner-box clear-both">
                                  <div className="full-fild mt-5">


                                    <div className="prvacy-box">
                                      <input
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value="I have read and agree to the terms and conditions"
                                        id="zoom_verification"
                                        type="checkbox"
                                        name="zoom_verification"

                                        checked={values.zoom_verification ? 'checked' : ''}
                                      />

                                      <label htmlFor="zoom_verification" className="width-unset">
                                        Able to connect to zoom
                                      </label>

                                    </div>
                                  </div>
                                </div>
                                <div className="bution">
                                  <button type="submit" className="button-bx">
                                    Update
                                  </button>
                                </div>
                              </form>
                            )}
                          </Formik>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </>}
          </TabPanel>
          {questioner !== "" && <TabPanel id={1} activeTab={activeTab}>
            <div className="min-height-80vh">
              <br />
              <br />

              {
                questioner !== "" && <>
                  <div>  <span className="font-weight-bolder"> Submission Date :</span>  <span>{questioner.created_at}</span></div>
                  <br />
                  <br />
                  <div>  <span className="font-weight-bolder"> How did you hear about VerySoul? :</span>  <span>{questioner.about_verysoul}</span></div>
                  <br />
                  <br />
                  <div>  <span className="font-weight-bolder">Have you had a fulfilling experience with an Evidential Medium before? :</span> <span>{questioner.past_experience}</span></div>
                  <br />
                  <br />
                  <div>  <span className="font-weight-bolder"> Are you a Medium or psychic? :</span> <span>{questioner.medium_psychic}</span></div>
                  <br />
                  <br />
                  <div>  <span className="font-weight-bolder"> Are you interested in volunteering in other ways for VS? :</span> <span>{questioner.help_text}</span></div>


                </>
              }
            </div>
          </TabPanel>}
        </ul>
      </div>
      {[1, 1, 1, 1].map(() => <div className="p-5 m-5"> </div>)}
    </>
  );
}
